"use strict";

const DEFAULT_STACK_BEHAVIOR = 'switch';
const DEFAULT_ENABLE_DISMISS_ON_CLOSE = true;
export { DEFAULT_STACK_BEHAVIOR, DEFAULT_ENABLE_DISMISS_ON_CLOSE };
//# sourceMappingURL=constants.js.map